import { render, staticRenderFns } from "./NavigationAccount.vue?vue&type=template&id=87c533c4&scoped=true&"
import script from "./NavigationAccount.vue?vue&type=script&lang=js&"
export * from "./NavigationAccount.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAccount.vue?vue&type=style&index=0&id=87c533c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c533c4",
  null
  
)

export default component.exports